import { useIsForegroundNow } from 'shared/src/hooks';
import { useEffect, useState } from 'react';
import { bridge, isNotNil, useAsyncEffect } from 'shared/src/utils';
import { useGoodsDetail } from '../queries/useGoodsDetail';

export const useIsFavoriteMarket = () => {
  const isForegroundNow = useIsForegroundNow();
  const { data: goodsDetail } = useGoodsDetail();

  const [isFavoriteMarket, setIsFavoriteMarket] = useState(
    goodsDetail?.goods.market.is_favorite ?? false,
  );
  //
  useAsyncEffect(async () => {
    if (!goodsDetail) {
      return;
    }
    if (isForegroundNow) {
      const localMarketLike = await bridge.getLocalMarketFavorite();

      if (isNotNil(localMarketLike)) {
        const localFavorite = localMarketLike[goodsDetail.goods.market.sno];
        if (isNotNil(localFavorite)) {
          setIsFavoriteMarket(localFavorite);
        }
      }
    }
  });

  useEffect(() => {
    if (goodsDetail) {
      setIsFavoriteMarket(goodsDetail?.goods.market.is_favorite ?? false);
    }
  }, [goodsDetail]);

  return {
    isFavoriteMarket,
  };
};
